var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.127 22.6613L1.02993 41.7682C0.790783 41.9063 0.790783 42.1301 1.02993 42.2682L27.0514 57.2903C27.2905 57.4284 27.6782 57.4284 27.9174 57.2903L61.0145 38.1834C61.2536 38.0454 61.2536 37.8215 61.0145 37.6834L34.993 22.6613C34.7539 22.5232 34.3662 22.5232 34.127 22.6613Z",
    fill: "#00004B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3772 51.5267L60.6749 33.2085C60.9092 33.0755 61.0413 32.8938 61.0413 32.7041L61.0413 29.7975C61.0413 29.6063 60.9071 29.4232 60.6693 29.29L36.9057 15.9825C36.4196 15.7102 35.6431 15.7174 35.1724 15.9985L32.388 17.6613L1.40689 33.7907C1.14936 33.9248 1.00236 34.1156 1.00236 34.3158V36.7063C1.00236 36.8963 1.13473 37.0782 1.36966 37.2112L26.6614 51.5272C27.138 51.7969 27.9011 51.7967 28.3772 51.5267Z",
    fill: "#38C7AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6939 14.9061L1.46293 33.5131C0.984623 33.7892 0.984624 34.2369 1.46293 34.513L26.6183 49.0352C27.0966 49.3113 27.8721 49.3113 28.3504 49.0352L60.5814 30.4282C61.0597 30.1521 61.0597 29.7044 60.5814 29.4283L35.426 14.9061C34.9477 14.63 34.1722 14.63 33.6939 14.9061Z",
    fill: "#5AF7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7167 16.625L1.46307 33.5131C0.984764 33.7892 0.984765 34.2369 1.46307 34.513L26.6184 49.0352C27.0967 49.3113 27.8722 49.3113 28.3505 49.0352L57.6042 32.1471L30.7167 16.625Z",
    fill: "#4AEBCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6468 19.5518L1.46307 33.5131C0.984764 33.7892 0.984765 34.2369 1.46307 34.513L26.6184 49.0352C27.0967 49.3113 27.8722 49.3113 28.3505 49.0352L52.5342 35.074L25.6468 19.5518Z",
    fill: "#5AF7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8366 22.9061L1.46307 33.5131C0.984764 33.7892 0.984765 34.2369 1.46307 34.513L26.6184 49.0352C27.0967 49.3113 27.8722 49.3113 28.3505 49.0352L46.724 38.4282L19.8366 22.9061Z",
    fill: "#4AEBCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8684 26.3515L1.46307 33.5131C0.984764 33.7892 0.984765 34.2369 1.46307 34.513L26.6184 49.0352C27.0967 49.3113 27.8722 49.3113 28.3505 49.0352L40.7558 41.8736C41.2341 41.5975 41.2341 41.1498 40.7558 40.8737L15.6005 26.3515C15.1222 26.0754 14.3467 26.0754 13.8684 26.3515Z",
    fill: "#5AF7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2522 28.4391L1.46307 33.5131C0.984764 33.7892 0.984765 34.2369 1.46307 34.513L26.6184 49.0352C27.0967 49.3113 27.8722 49.3113 28.3505 49.0352L37.1396 43.9613L10.2522 28.4391Z",
    fill: "#4AEBCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4676 31.7783L1.46271 33.513C0.98441 33.7892 0.98441 34.2369 1.46271 34.513L26.6181 49.0352C27.0964 49.3113 27.8719 49.3113 28.3502 49.0352L31.3551 47.3005C31.8334 47.0243 31.8334 46.5766 31.3551 46.3005L6.19968 31.7783C5.72138 31.5022 4.9459 31.5022 4.4676 31.7783Z",
    fill: "#5AF7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33351 31.2784L1.46258 33.5131C0.984276 33.7892 0.984277 34.2369 1.46258 34.513L26.618 49.0352C27.0963 49.3113 27.8717 49.3113 28.35 49.0352L32.221 46.8005L5.33351 31.2784Z",
    fill: "#5AF7DC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2086 31.0451C37.5532 29.6915 37.5532 27.4969 35.2086 26.1433C32.8639 24.7898 29.0625 24.7898 26.7178 26.1433C24.3731 27.4969 24.3731 29.6915 26.7178 31.0451C29.0625 32.3986 32.8639 32.3986 35.2086 31.0451Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20546 34.415L14.7075 31.2387C15.1858 30.9626 15.9613 30.9626 16.4396 31.2387L26.3823 36.9786C26.8606 37.2547 26.8606 37.7024 26.3823 37.9786L20.8803 41.1549",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0459 16.0335L35.5439 19.2099C35.0656 19.486 35.0656 19.9337 35.5439 20.2098L45.4866 25.9497C45.9649 26.2259 46.7404 26.2259 47.2187 25.9497L52.7208 22.7734",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.227 21.2416L43.6994 35.9468",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2811 12.5509L3.1728 29.9324C2.6945 30.2085 2.6945 30.6562 3.1728 30.9323L26.913 44.6376C27.3913 44.9137 28.1668 44.9137 28.6451 44.6376L58.7535 27.256C59.2318 26.9799 59.2318 26.5322 58.7535 26.2561L35.0132 12.5509C34.5349 12.2747 33.7594 12.2747 33.2811 12.5509Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.2164,
    height: 39.2164,
    fill: "white",
    transform: "matrix(0.866044 -0.499967 0.866044 0.499967 -3 28.5942)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitch);
export default __webpack_public_path__ + "static/media/pitch.ba3ad45260576d9f78ae4ba088a4638d.svg";
export { ForwardRef as ReactComponent };